var BadgeComponent = /** @class */ (function () {
    function BadgeComponent() {
        this.compact = false;
    }
    Object.defineProperty(BadgeComponent.prototype, "tooltip", {
        get: function () {
            return this.compact ? this.label : null;
        },
        enumerable: true,
        configurable: true
    });
    return BadgeComponent;
}());
export { BadgeComponent };
